import { render } from "./Router3.vue?vue&type=template&id=fdb6996e&scoped=true"
import script from "./Router3.vue?vue&type=script&lang=js"
export * from "./Router3.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhwf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb6996e"]])

export default __exports__